"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext } from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import { getTimeAgo, numberWithCommas } from "@/helpers/Helpers";
import WaveHeaderFollow from "./WaveHeaderFollow";
import { AuthContext } from "@/components/auth/Auth";
import WaveHeaderOptions from "./options/WaveHeaderOptions";
import WaveHeaderName from "./name/WaveHeaderName";
import WaveHeaderFollowers from "./WaveHeaderFollowers";
import WaveHeaderDescription from "./WaveHeaderDescription";
import WaveHeaderPinButton from "./WaveHeaderPinButton";
import { ApiWaveType } from "@/generated/models/ObjectSerializer";
import WavePicture from "../WavePicture";
import { Time } from "@/helpers/time";
import WaveNotificationSettings from "../specs/WaveNotificationSettings";
export enum WaveHeaderPinnedSide {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}
interface WaveHeaderProps {
  readonly wave: ApiWave;
  readonly onFollowersClick: () => void;
  readonly useRing?: boolean | undefined;
  readonly useRounded?: boolean | undefined;
  readonly pinnedSide?: WaveHeaderPinnedSide | undefined;
}
export default function WaveHeader(t0) {
  const $ = _c(77);
  const {
    wave,
    onFollowersClick,
    useRing: t1,
    useRounded: t2,
    pinnedSide: t3
  } = t0;
  const useRing = t1 === undefined ? true : t1;
  const useRounded = t2 === undefined ? true : t2;
  const pinnedSide = t3 === undefined ? WaveHeaderPinnedSide.RIGHT : t3;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  let t4;
  if ($[0] !== wave.created_at) {
    t4 = getTimeAgo(wave.created_at);
    $[0] = wave.created_at;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const created = t4;
  let t5;
  if ($[2] !== wave.contributors_overview) {
    t5 = wave.contributors_overview.slice(0, 10);
    $[2] = wave.contributors_overview;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const firstXContributors = t5;
  const isDropWave = wave.wave.type !== ApiWaveType.Chat;
  const ringClasses = useRing ? "tw-rounded-xl tw-ring-1 tw-ring-inset tw-ring-iron-800/60 tw-shadow-sm" : useRounded ? "tw-rounded-t-xl lg:tw-rounded-t-none" : "";
  const t6 = `tw-bg-iron-950 tw-relative tw-overflow-auto ${ringClasses}`;
  const t7 = `${useRounded ? "tw-rounded-t-xl tw-ring-1 tw-ring-inset tw-ring-iron-800/70" : ""} tw-overflow-hidden`;
  const t8 = `linear-gradient(60deg, ${wave.author.banner1_color} 0%, ${wave.author.banner2_color} 100%)`;
  let t9;
  if ($[4] !== t8) {
    t9 = <div className="tw-h-14 tw-w-full tw-object-cover" style={{
      background: t8,
      boxShadow: "inset 0 -4px 12px rgba(0,0,0,0.15)"
    }} />;
    $[4] = t8;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  if ($[6] !== t7 || $[7] !== t9) {
    t10 = <div className={t7}>{t9}</div>;
    $[6] = t7;
    $[7] = t9;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  const t11 = `tw-absolute tw-inset-0 tw-rounded-full tw-bg-iron-900 tw-overflow-hidden tw-shadow-md ${isDropWave ? "tw-ring-2 tw-ring-white/10" : ""}`;
  const t12 = wave.name;
  const t13 = wave.picture;
  let t14;
  if ($[9] !== wave.contributors_overview) {
    t14 = wave.contributors_overview.map(_temp);
    $[9] = wave.contributors_overview;
    $[10] = t14;
  } else {
    t14 = $[10];
  }
  let t15;
  if ($[11] !== t14 || $[12] !== wave.name || $[13] !== wave.picture) {
    t15 = <WavePicture name={t12} picture={t13} contributors={t14} />;
    $[11] = t14;
    $[12] = wave.name;
    $[13] = wave.picture;
    $[14] = t15;
  } else {
    t15 = $[14];
  }
  let t16;
  if ($[15] !== t11 || $[16] !== t15) {
    t16 = <div className={t11}>{t15}</div>;
    $[15] = t11;
    $[16] = t15;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] !== isDropWave) {
    t17 = isDropWave && <div className="tw-absolute tw-bottom-0 tw-right-0 tw-size-6 tw-flex tw-items-center tw-justify-center tw-bg-iron-950 tw-rounded-full tw-shadow-md tw-border tw-border-iron-800/50"><svg className="tw-size-4 tw-flex-shrink-0 tw-text-[#E8D48A]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M400 0L176 0c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8L24 64C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9L192 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-26.1 0C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24L446.4 64c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112l84.4 0c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6l84.4 0c-5.1 66.3-31.1 111.2-63 142.3z" /></svg></div>;
    $[18] = isDropWave;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  let t18;
  if ($[20] !== t16 || $[21] !== t17) {
    t18 = <div className="tw-flex"><div className="tw-relative tw-size-20">{t16}{t17}</div></div>;
    $[20] = t16;
    $[21] = t17;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== activeProfileProxy || $[24] !== connectedProfile?.handle || $[25] !== wave) {
    t19 = !!connectedProfile?.handle && !activeProfileProxy && <div className="tw-inline-flex tw-space-x-2 tw-items-center"><WaveNotificationSettings wave={wave} /><WaveHeaderFollow wave={wave} /></div>;
    $[23] = activeProfileProxy;
    $[24] = connectedProfile?.handle;
    $[25] = wave;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] !== t19) {
    t20 = <div className="tw-mt-10 tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-justify-end tw-gap-x-3 tw-pb-1"><div className="tw-min-w-0 tw-flex-1"><div className="tw-flex tw-flex-col tw-items-end">{t19}</div></div></div>;
    $[27] = t19;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== t18 || $[30] !== t20) {
    t21 = <div className="-tw-mt-6 tw-px-4 tw-flex tw-space-x-5">{t18}{t20}</div>;
    $[29] = t18;
    $[30] = t20;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== wave) {
    t22 = <div className="tw-flex-1"><WaveHeaderName wave={wave} /></div>;
    $[32] = wave;
    $[33] = t22;
  } else {
    t22 = $[33];
  }
  let t23;
  if ($[34] !== activeProfileProxy || $[35] !== connectedProfile?.handle || $[36] !== wave.id) {
    t23 = !!connectedProfile?.handle && !activeProfileProxy && <WaveHeaderPinButton waveId={wave.id} />;
    $[34] = activeProfileProxy;
    $[35] = connectedProfile?.handle;
    $[36] = wave.id;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== activeProfileProxy || $[39] !== connectedProfile || $[40] !== wave) {
    t24 = !!connectedProfile?.handle && !activeProfileProxy && connectedProfile.handle === wave.author.handle && <WaveHeaderOptions wave={wave} />;
    $[38] = activeProfileProxy;
    $[39] = connectedProfile;
    $[40] = wave;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== t23 || $[43] !== t24) {
    t25 = <div className="tw-flex tw-items-center tw-self-start tw-justify-end tw-gap-x-2">{t23}{t24}</div>;
    $[42] = t23;
    $[43] = t24;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] !== t22 || $[46] !== t25) {
    t26 = <div className="tw-flex tw-justify-between tw-w-full tw-gap-x-4">{t22}{t25}</div>;
    $[45] = t22;
    $[46] = t25;
    $[47] = t26;
  } else {
    t26 = $[47];
  }
  let t27;
  if ($[48] !== wave.created_at) {
    t27 = Time.millis(wave.created_at).toDate().toLocaleDateString();
    $[48] = wave.created_at;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  let t28;
  if ($[50] !== created || $[51] !== t27) {
    t28 = <div className="tw-text-sm tw-flex-1"><span className="tw-font-normal tw-text-iron-400/90">Created {created} ·{" "}{t27}</span></div>;
    $[50] = created;
    $[51] = t27;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  let t29;
  if ($[53] !== pinnedSide || $[54] !== wave) {
    t29 = <WaveHeaderDescription wave={wave} side={pinnedSide} />;
    $[53] = pinnedSide;
    $[54] = wave;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] !== t28 || $[57] !== t29) {
    t30 = <div className="tw-flex tw-items-center tw-justify-between tw-mt-2">{t28}{t29}</div>;
    $[56] = t28;
    $[57] = t29;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== onFollowersClick || $[60] !== wave) {
    t31 = <WaveHeaderFollowers wave={wave} onFollowersClick={onFollowersClick} />;
    $[59] = onFollowersClick;
    $[60] = wave;
    $[61] = t31;
  } else {
    t31 = $[61];
  }
  let t32;
  if ($[62] !== firstXContributors.length || $[63] !== wave.metrics) {
    t32 = !!firstXContributors.length && <div className="tw-flex tw-items-center"><span className="tw-font-normal tw-ml-2.5 tw-text-iron-400 tw-text-sm"><span className="tw-text-iron-50 tw-pr-0.5 tw-font-medium">{numberWithCommas(wave.metrics.drops_count)}</span>{wave.metrics.drops_count === 1 ? "Post" : "Posts"}</span></div>;
    $[62] = firstXContributors.length;
    $[63] = wave.metrics;
    $[64] = t32;
  } else {
    t32 = $[64];
  }
  let t33;
  if ($[65] !== t31 || $[66] !== t32) {
    t33 = <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-y-3"><div className="tw-flex tw-gap-x-4 tw-items-center tw-justify-between"><div className="tw-flex tw-items-center tw-gap-x-4">{t31}{t32}</div></div></div>;
    $[65] = t31;
    $[66] = t32;
    $[67] = t33;
  } else {
    t33 = $[67];
  }
  let t34;
  if ($[68] !== t26 || $[69] !== t30 || $[70] !== t33) {
    t34 = <div className="tw-px-4 tw-pb-4 tw-mt-2 tw-min-w-0 tw-flex-1">{t26}{t30}{t33}</div>;
    $[68] = t26;
    $[69] = t30;
    $[70] = t33;
    $[71] = t34;
  } else {
    t34 = $[71];
  }
  let t35;
  if ($[72] !== t10 || $[73] !== t21 || $[74] !== t34 || $[75] !== t6) {
    t35 = <div className={t6}>{t10}{t21}{t34}</div>;
    $[72] = t10;
    $[73] = t21;
    $[74] = t34;
    $[75] = t6;
    $[76] = t35;
  } else {
    t35 = $[76];
  }
  return t35;
}
function _temp(c) {
  return {
    pfp: c.contributor_pfp
  };
}